var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91 1.5h3.78a3.4 3.4 0 0 1 3.44 3.33v8.34a3.39 3.39 0 0 1-3.45 3.33H8.9a3.4 3.4 0 0 1-3.44-3.32v-3.6h4.8l-1.24 1.2a.57.57 0 0 0 0 .82.6.6 0 0 0 .43.16.6.6 0 0 0 .41-.16l2.27-2.19c.11-.1.17-.25.17-.41 0-.15-.06-.3-.17-.4L9.87 6.4a.61.61 0 0 0-.84 0 .57.57 0 0 0 0 .82l1.24 1.2h-4.8v-3.6A3.4 3.4 0 0 1 8.9 1.5ZM1.87 9c0-.32.27-.58.6-.58h3v1.16h-3a.58.58 0 0 1-.6-.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutmedium);
export default __webpack_public_path__ + "static/media/logout.medium.ff6c5933d220c8fad4cbb5db0ee9c2fb.svg";
export { ForwardRef as ReactComponent };